module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAYFBMVEUAAAB4eHh6enp4eHh5eXl0dHR5eXl/f394eHh3d3d4eHh2dnZ4eHh2dnZ4eHh3d3d4eHh4eHh4eHh4eHh3d3d3d3d3d3d5eXl4eHh4eHh4eHh3d3d/f393d3d3d3d4eHjNxRB3AAAAH3RSTlMArzBwjxhQCOf3zzhoWKd434e/nyCXQChIx++3ENdgNC88wgAAAMZJREFUeNrt0tVhAzEYBOE55juzw9t/l+FE0sod+HsX/sPdj+txw7XrROBBPa7QTGinltRJQ0eo0jOpWjWRZtCVWNerJHZMl7HoQGJS3xF51EJq1Buh0lYBs0ZCZ+0x3VN0z25Qg6t1jv6kAFdqeAmv2JJzUMWvi3ZktXrl1/q3wL/48jeAoSFv/3fZTSs3NPpd32vilkLbz+1GIt6e14a357Xh7Xlt1t4Jr83b89py7Xlt3l7ttXl78trw9qw2V3ttrvTa3gEabwvlZgCtPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/∨.png
// module id = o50p
// module chunks = 2